import styles from './NormalReviewFrame.module.scss';
import star from '../../assets/star.png';
import emptyStar from '../../assets/emptyStar.png';
import verified from '../../assets/verified.png';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import { useState } from 'react';
import ReviewDetailModal from '../ReviewDetailModal/ReviewDetailModal';
import { useTranslation } from 'react-i18next';

function NormalReviewFrame(props: { review: IReviewDataType }) {
  const { t } = useTranslation();
  const [reviewDetailOpen, setReviewDetailOpen] = useState(false);
  
  const rating = Math.round(
    (props.review.stars0 +
      props.review.stars1 +
      props.review.stars2 +
      props.review.stars3) /
      4 /
      20,
  );

  return (
    <div className={styles.container}>
      <div className={styles.userInfoSection}>
        <span className={styles.userId}>{props.review.member_id.substring(0, 15)}</span>
        <div className={styles.verified}>
          Verified Buyer <img src={verified} alt="Verified Buyer" />
        </div>
        <div className={styles.userDetails}>
          <p>age: {props.review.age}s</p>
          <p>
            gender: {props.review.gender == 'F'
              ? t('productDetail.37')
              : t('productDetail.36')}
          </p>
          {props.review.weight > 0 && <p>lost weight: -{props.review.weight}kg</p>}
        </div>
      </div>
      <div className={styles.reviewContentSection}>
        <div className={styles.starWrap}>
          {[...Array(5)].map((_, idx) => (
            <img key={idx} src={idx < rating ? star : emptyStar} alt="star" />
          ))}
          <span className={styles.rating}>({rating}.0)</span>
        </div>
        <p className={styles.content}>{props.review.content}</p>
        <div className={styles.reviewImageWrap}>
          {props.review.images
            .filter((_, idx) => idx < 3)
            .map((image) => (
              <img
                src={image.image + '?w=570'}
                alt="reviewImage"
                key={image.id}
                onClick={() => setReviewDetailOpen(true)}
              />
            ))}
        </div>
      </div>
      {reviewDetailOpen && (
        <ReviewDetailModal
          closer={setReviewDetailOpen}
          imageList={props.review.images}
          userId={props.review.member_id}
          age={props.review.age}
          gender={props.review.gender}
          weight={props.review.weight}
          score={
            props.review.stars0 +
            props.review.stars1 +
            props.review.stars2 +
            props.review.stars3
          }
          content={props.review.content}
          productImage={props.review.product.list_image}
        />
      )}
    </div>
  );
}

export default NormalReviewFrame;
